
import { useEffect, useState } from 'react';
import { 
  EnhancedLogEntry, 
  getLogs, 
  clearLogs, 
  initEnhancedLogging,
  getQueryVersion
} from '@/utils/enhancedLogging';

export const useDiagnosticLog = () => {
  const [logs, setLogs] = useState<EnhancedLogEntry[]>([]);
  const [queryVersion, setQueryVersion] = useState<string>('');

  useEffect(() => {
    // Initialize enhanced logging if not already done
    initEnhancedLogging();
    
    // Get current query version
    setQueryVersion(getQueryVersion());
    
    // Update logs every 500ms
    const intervalId = setInterval(() => {
      setLogs(getLogs());
    }, 500);
    
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  const handleClearLogs = () => {
    clearLogs();
    setLogs([]);
  };

  return {
    logs,
    clearLogs: handleClearLogs,
    queryVersion
  };
};
